import { styled } from '@/styled-system/jsx';
import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR, {
  base: {
    width: '142px',
  },
});
